// 部屋編集エラー情報
const RoomSaveError = {
  namespaced: true,
  state: {
    modalError: false,
    modalConfirm: false,
    modalEditor: false,
    error: {},
    confirm: {},
  },
  getters: {
    getModalError: state => {
      return state.modalError
    },
    getModalConfirm: state => {
      return state.modalConfirm
    },
    getModalEditor: state => {
      return state.modalEditor
    },
    getError: state => {
      return state.error
    },
    getConfirm: state => {
      return state.confirm
    },
  },
  mutations: {
    setModalError(state, modal) {
      state.modalError = modal
    },
    setModalConfirm(state, modal) {
      state.modalConfirm = modal
    },
    setModalEditor(state, modal) {
      state.modalEditor = modal
    },
    setError(state, error) {
      state.error = error
    },
    setConfirm(state, confirm) {
      state.confirm = confirm
    },
  },
  actions: {
    setError({ commit }, item) {
      commit('setError', item.error)
      commit('setModalError', true)
    },
    resetError({ commit }) {
      commit('setModalError', false)
      commit('setError', {})
    },
    setConfirm({ commit }, item) {
      commit('setConfirm', item.confirm)
      commit('setModalConfirm', true)
    },
    resetConfirm({ commit }) {
      commit('setModalConfirm', false)
      commit('setConfirm', {})
    },
    resetEditor({ commit }) {
      commit('setModalEditor', false)
      commit('setConfirm', {})
      commit('setError', {})
    },
  },
}

export default RoomSaveError
